"use client";

import Pagination from "rc-pagination";
import "@/app/paging.css";
import { useRouter, useSearchParams } from "next/navigation";
import { routes } from "@/lib/utils/routes";

export const JobListPaging = ({
  page = 1, // default page is 1
  total,
}: {
  page: number;
  total: number;
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());
  const onChangePage = (page: number) => {
    params.set("page", page.toString());
    router.push(`${routes.job.index}?${params.toString()}`);
  };

  return (
    <div className="w-full p-5 flex justify-center items-center">
      {total && total > 0 && (
        <Pagination
          pageSize={20}
          className="ant-pagination"
          onChange={onChangePage}
          current={page}
          total={total}
        />
      )}
    </div>
  );
};
